<template>
  <div id="app">
    <layout></layout>
    <!--
      <img src="./assets/logo.png">
      <router-view></router-view>
    -->
  </div>
</template>

<script>
import Layout from '@/components/Layout'

export default {
  name: 'app',
  components: { Layout },
  data () {
    return {
      user: null,
      token: null,
      authenticated: true,
    }
  },
  methods: {
    login: function(user) {
      this.user = user
      this.authenticated = true
      this.token = localStorage.getItem('jwt-token')
    },
    extlogin: function(user) {
      //console.log(user)
      this.user = user
      this.authenticated = true
      this.token = localStorage.getItem('ext-token')
      this.$router.push('/dashboard/statistics/maincategories')
    },
    logout: function(user) {
      this.user = null
      this.token = null
      this.authenticated = false
      localStorage.removeItem('jwt-token')
      if (this.$route.auth) this.$router.push('/auth/login')
    }
  },
  mounted () {
    this.$on('userLoggedIn', (user) => {
      this.login(user)
    })

    this.$on('userLoggedOut', (user) => {
      this.logout(user)
    })

    var token = localStorage.getItem('jwt-token')
    if (token !== null && token !== 'undefined' && !localStorage.getItem('ext-token')) {
        //alert(11)
        var that = this
        that.$http.get('/api/users/details').then((response) => {
            that.login(response.json()['data'])
        }, (response) => {
            that.logout()
        })
    }
    else if(this.$route.query.token != null && this.$route.query.token != 'undefined' || localStorage.getItem('ext-token')) {
      //alert(22)      
      var that = this
      //if(this.$route.query.kb!='') user.kb = this.$route.query.kb
      localStorage.setItem('ext-token',this.$route.query.token ? this.$route.query.token : localStorage.getItem('ext-token'))
      localStorage.setItem('ext-kunde',this.$route.query.kunde ? this.$route.query.kunde : localStorage.getItem('ext-kunde'))
      localStorage.setItem('ext-kb',this.$route.query.kb ? this.$route.query.kb : localStorage.getItem('ext-kb'))

      //alert( localStorage.getItem('ext-kunde') )

      that.extlogin({pno: localStorage.getItem('ext-kunde'),name:'',username:''})
    }
    else {
      //alert(33)
      this.$router.push('/auth/login')
    }
  }
}
</script>

<style src="./App.sass" lang="sass?indentedSyntax"></style>


// WEBPACK FOOTER //
// App.vue?7e7294a4